import { render, staticRenderFns } from "./FormTipoAtendimento.vue?vue&type=template&id=99f436a6"
import script from "./FormTipoAtendimento.vue?vue&type=script&lang=js"
export * from "./FormTipoAtendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports